const PAYSLIPS_IMPORT_TABLE_BULK_ACTIONS = "payslips.import.table.bulk.actions";
const PAYSLIPS_IMPORT_TABLE_STATUS_REMOVE =
  "payslips.import.table.status.remove";
const PAYSLIP_NOTIFICATIONS_SEND_OPTION = "payslip.notifications.send.option";
const IRP5_NOTIFICATIONS_SEND_OPTION = "irp5.notifications.send.option";
const ROSTER_TIMESHEET_NOTIFICATIONS_SEND_OPTION =
  "roster-timesheet.notifications.send.option";
const PAYSLIPS_CANCEL_FINALIZED =
  "employerportal.payslips_cancel_finalized.temp";

const EMPLOYER_PORTAL_AUTOMATED_ODP_INVOICING_VIEW =
  "employerportal.automated_odp_invoicing.view";
const EMPLOYER_PORTAL_AUTOMATED_ODP_INVOICING_UPDATE_DATES =
  "employerportal.automated_odp_invoicing.dates.update";
const EMPLOYER_PORTAL_IRP5_VIEW = "employerportal.irp5.view";
const EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW =
  "employerportal.roster-timesheet.view";
const EMPLOYER_PORTAL_ODP_LIMITS_VIEW = "employerportal.odp_limits.view";
const EMPLOYEE_BULK_STATUS_UPDATE = "employerportal.bulkstatus-update.temp";

const EMPLOYEE_IMPORTER_TOOLS = "employerportal.importer_tools.temp";
const EMPLOYEE_IMPORTER_TOOLS_V2 = "employerportal.importer_tools_v2.temp";

const EMPLOYER_ODP_LIMITS_TRANSACTIONAL =
  "employerportal.odp_limits.transactional";
const EMPLOYER_ODP_LIMITS_BLOCKED_DATES =
  "employerportal.odp_limits.blocked_dates";

const HELP_CENTER = "adminportal.help_center.temp";
const COMING_SOON = "employerportal.coming_soon_features.temp";

const ANNOUNCMENT_TYPES = "employerportal.announcement_types.temp";
const UNMATCHED_PAYSLIPS_SEARCH_BAR =
  "employerportal.unmatched_payslips.searchbar";

const SSE_CONNECT = "employerportal.sse.connect";
const SNACKBARS = "employerportal.snackbars";

const EWA_VOLUME_LIMITS = "employerportal.ewa_volume_limits.temp";

const EMPLOYEE_TICKETING_SERVICE_NOTIFY_EMPLOYEE =
  "api.employee_ticketing_service_notify_employee";
const EMPLOYEE_TICKETING_SERVICE_GENERAL_AVAILABILITY =
  "api.employee_ticketing_service.general.availability";

const QUERY_INBOX_RESOLUTION_OUTCOME_DATA_ENABLED =
  "employerportal.query_inbox.resolution_reason_enabled";
const QUERY_INBOX_LEAVE_EXPORTS_ENABLED =
  "employerportal.query_inbox.leave_exports_enabled";
const QUERY_INBOX_FILTERS = "employerportal.query_inbox.filters";

const WHATSAPP_EMBEDDED_SIGNUP =
  "employerportal.enterprise.whitelabel.whatsapp_embedded_signup";

const SECURE_EMPLOYER_UPLOADS = "employerportal.secure_employer_uploads";

const ANNOUNCEMENTS_ATTACHMENTS_ENABLE_GCP =
  "announcements.attachments.enable_gcp";

const AI_INSIGHTS = "employerportal.ai_insights";
const SEGMENTS = "employerportal.segments";

const EMPLOYER_ODP_SEGMENTATION_BLOCKS =
  "employerportal.odp_limits.segmentation_blocks";

const SEGMENTS_ANNOUNCEMENTS = "employerportal.segments.announcements";
const SEGMENTS_SURVEYS = "employerportal.segments.surveys";

const JEMHR_ATTENDANCE = "employerportal.jemhr.attendance";

const MULTIMESSAGING = "employerportal.multimessaging";

const REPORTS_AGENT_UI = "employerportal.reports_agent_ui";

const JEM2_MIGRATED = "employerportal.jem2.migrated";

const JEM2_MIGRATION_SCHEDULED = "employerportal.jem2.migration_scheduled";

// Cut-off. Separate from JEM2_MIGRATED on purpose: read-only is a nudge an employer
// can live in for weeks, while this ends their use of the old hub entirely. Keeping
// them apart means a cohort can sit read-only for as long as it needs, and the cut-off
// can be turned on — and off again in seconds — without disturbing that.
const JEM2_REDIRECT = "employerportal.jem2.redirect";

export default {
  EMPLOYER_PORTAL_AUTOMATED_ODP_INVOICING_UPDATE_DATES,
  EMPLOYER_PORTAL_AUTOMATED_ODP_INVOICING_VIEW,
  PAYSLIPS_IMPORT_TABLE_BULK_ACTIONS,
  PAYSLIPS_IMPORT_TABLE_STATUS_REMOVE,
  PAYSLIP_NOTIFICATIONS_SEND_OPTION,
  IRP5_NOTIFICATIONS_SEND_OPTION,
  PAYSLIPS_CANCEL_FINALIZED,
  EMPLOYER_PORTAL_IRP5_VIEW,
  EMPLOYER_PORTAL_ODP_LIMITS_VIEW,
  EMPLOYEE_BULK_STATUS_UPDATE,
  EMPLOYEE_IMPORTER_TOOLS,
  EMPLOYER_ODP_LIMITS_BLOCKED_DATES,
  EMPLOYER_ODP_LIMITS_TRANSACTIONAL,
  HELP_CENTER,
  COMING_SOON,
  ANNOUNCMENT_TYPES,
  EMPLOYEE_IMPORTER_TOOLS_V2,
  UNMATCHED_PAYSLIPS_SEARCH_BAR,
  ROSTER_TIMESHEET_NOTIFICATIONS_SEND_OPTION,
  EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW,
  SSE_CONNECT,
  SNACKBARS,
  EWA_VOLUME_LIMITS,
  QUERY_INBOX_RESOLUTION_OUTCOME_DATA_ENABLED,
  EMPLOYEE_TICKETING_SERVICE_NOTIFY_EMPLOYEE,
  EMPLOYEE_TICKETING_SERVICE_GENERAL_AVAILABILITY,
  QUERY_INBOX_LEAVE_EXPORTS_ENABLED,
  QUERY_INBOX_FILTERS,
  WHATSAPP_EMBEDDED_SIGNUP,
  SECURE_EMPLOYER_UPLOADS,
  ANNOUNCEMENTS_ATTACHMENTS_ENABLE_GCP,
  AI_INSIGHTS,
  SEGMENTS,
  EMPLOYER_ODP_SEGMENTATION_BLOCKS,
  SEGMENTS_ANNOUNCEMENTS,
  SEGMENTS_SURVEYS,
  JEMHR_ATTENDANCE,
  MULTIMESSAGING,
  REPORTS_AGENT_UI,
  JEM2_MIGRATED,
  JEM2_MIGRATION_SCHEDULED,
  JEM2_REDIRECT,
};
